// extracted by mini-css-extract-plugin
module.exports = {"background":"Loader_background__3l4OY","loaderAnimation":"Loader_loaderAnimation__2I799"};